Controller = require 'controller'
WarningBannerView = require 'views/header/warning-banner-view'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class PublicBoardBannerView extends WarningBannerView
  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @render

  render: ->
    data = @model.toJSON()

    prefs = @model.get('prefs')
    couldVote = prefs.voting == 'public'
    couldComment = prefs.comments == 'public'

    key = if couldVote && couldComment
      'subscribe vote comment'
    else if couldVote
      'subscribe vote'
    else if couldComment
      'subscribe comment'
    else
      'subscribe'

    data.interactionText = l(['public interactions', key])
    data.ctaKey = 'sign-up-for-free'

    # TODO gerard replace with a international version!
    if /^en/.test(window.locale)
      data.interactionText = "Visually collaborate with anyone, anywhere."

    if @model.get('id') == '5a26bae36c0e623f622121f9'
      data.interactionText = l(['adventure campaign interaction'])
      data.ctaKey = 'sign-up-its-free'

    urlEscaped = encodeURIComponent(Controller.getBoardUrl(@model))

    data.signupUrl = "/signup?returnUrl=#{ urlEscaped }&source=public-board-banner"

    @$el.html(
      templates.fill(
        'header_public_board',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/public-board-banner-view.coffee